import { useEffect, useState } from "react";
import { MainCard, MainCardTitle } from "src/components/main-card-type.tsx";
import { normalSanatizerBRL } from "src/utils/functions";
import { Vis_PraResult } from "../Vista-Prazo";
import { VistaPrazoGraph } from "./vista-prazo-graphist";
import { VistaPrazoTable } from "./vista-prazo-Table";

export const VistaPrazoResponse = ({ results }: { results: Vis_PraResult }) => {
  let valorPrazo = results.prazoFinal;
  const [handleGraphist, setHandleGraphist] = useState(false);

  useEffect(() => {
    if (valorPrazo > 0) {
      setHandleGraphist(true);
    } else {
      setHandleGraphist(false);
    }
  }, [valorPrazo]);

  return (
    <MainCard className="mt-4">
      <MainCardTitle>Resultado</MainCardTitle>

      <div className="flex justify-center mb-2">
        <div className="w-full sm:w-1/2 lg:w-1/3 p-3 bg-primary rounded border flex flex-col justify-center mb-4">
          <h2 className="sm:text-base text-sm text-center text-white font-semibold m-0">
            A melhor forma de pagamento para você é:
          </h2>
          <p className="sm:text-xl text-center font-bold text-md text-white m-0">
            À {results.resultType}
          </p>
        </div>
      </div>
      <div className="flex flex-col md:flex-row md:justify-center gap-4 md:gap-10 mx-4 md:mx-10 mb-4 ">
        <div className="p-3 bg-white rounded-md border flex flex-col w-full md:w-[47%] justify-center ">
          <h2 className="sm:text-base text-sm text-center font-semibold m-0">
            Total à vista
          </h2>
          <p className="sm:text-lg text-center font-black text-2xl text-red-700 m-0">
            <span className="text-sm mr-1 text-gray-500">R$</span>
            {normalSanatizerBRL(results.vistaFinal)}
          </p>
        </div>

        <div className="p-3 bg-white rounded border flex flex-col w-full md:w-[47%] justify-center">
          <h2 className="sm:text-base text-sm text-center font-semibold m-0">
            Total à Prazo
          </h2>
          <p className="sm:text-lg text-center font-black text-2xl text-black m-0">
            <span className="text-sm mr-1 text-gray-500">R$</span>
            {normalSanatizerBRL(results.prazoFinal)}
          </p>
        </div>
      </div>

      {handleGraphist ? (
        <VistaPrazoGraph results={results} />
      ) : (
        <VistaPrazoTable results={results} />
      )}
      {/* <VistaPrazoTable results={results} />
            {handleGraphist && <VistaPrazoGraph results={results} />} */}
    </MainCard>
  );
};
